define([
    "./monitorModule",
    "text!./nlgMonitorHealth.html"
], function (module, template) {
    "use strict";

    return module.directive("nlgMonitorHealth", [function () {
        return {
            scope: {
                instance: "<"
            },
            template: template,
            controller: [
                "$scope",
                "monitorService",
                "$q",
                function ($scope, monitorService, $q) {
                    $scope.health = {
                        value: null,
                        error: null
                    };

                    $scope.loadEndpoint = function () {
                        $scope.loading = true;

                        return $q.all([loadHealth()])
                            .finally(function () {
                                $scope.loading = false;
                            });
                    };

                    function loadHealth() {
                        $scope.health.value = null;
                        $scope.health.error = null;

                        return monitorService.findEndpoint($scope.instance, "health")
                            .then(function (data) {
                                $scope.health.value = data;
                            })
                            .catch(function (error) {
                                $scope.health.error = error;
                            });
                    }



                    $scope.loadEndpoint();
                }]
        };
    }]);
});